module.exports = __webpack_public_path__ + "img/H6951.3eef26ab.jpg";